import { CheckCircleFilled } from '@ant-design/icons';
import { Modal, Select, Typography } from 'antd';
import React, { useState } from 'react';

import {useWeb3ExecuteFunction, useMoralis} from "react-moralis"
const {Paragraph} = Typography

function LockConfig() {
  
  const {Moralis} = useMoralis()
 const [exiAddress, setExiAddress] = useState("") 
 const [lockAddress, setLockAddress] = useState("") 
 const [networkAddress, setnetworkAddress] = useState("0x910F56Fb797D9c7a978a08e73D7280e67eb81372") 
 const [isModalVisible, setIsModalVisible] = useState(false);
 const [isComfirmVisible, setIsComfirmVisible] = useState(false);
 const [notes, setNotes] = useState("")
const unlockABI = [{"inputs":[{"internalType":"address","name":"_lockAddress","type":"address"},{"internalType":"address","name":"_nftAddress","type":"address"}],"name":"createMapping","outputs":[],"stateMutability":"nonpayable","type":"function"}]
const maticABIs = [{"inputs":[{"internalType":"string","name":"note","type":"string"}],"name":"newDonation","outputs":[],"stateMutability":"payable","type":"function"}]
const setEventABI = [{"inputs":[{"internalType":"address","name":"_onKeyPurchaseHook","type":"address"},
{"internalType":"address","name":"_onKeyCancelHook","type":"address"},
{"internalType":"address","name":"_onValidKeyHook","type":"address"},
{"internalType":"address","name":"_onTokenURIHook","type":"address"}],"name":"setEventHooks","outputs":[],"stateMutability":"nonpayable","type":"function"},]
const setEventAddress = "0xa55F8Ba16C5Bb580967f7dD94f927B21d0acF86c"
const myLockContract = "0x289228065de389C200F00c7335e83d24Af371e0e"
const  unlockCAddress = "0x910F56Fb797D9c7a978a08e73D7280e67eb81372"
const zeroAddress = "0x0000000000000000000000000000000000000000"
const contractCaller = useWeb3ExecuteFunction()
 async function config() {
   let options = {
     contractAddress:  networkAddress,
     functionName: "createMapping",
      abi: unlockABI,
      //Parameters 
      params: {
       
        _lockAddress: lockAddress,
        _nftAddress: exiAddress
        
      },
     
      
   }
   await contractCaller.fetch({
     params: options,
     onSuccess:() =>{
       setIsModalVisible(true)
     },
     onError: (errori) =>{
       alert(errori.message)
     }
   })
   console.log("clicked button")
 }
 //caliing  set event  hook
 async function callEventHook() {
  let options = {
    contractAddress:  lockAddress,
    functionName: "setEventHooks",
     abi: setEventABI,
     //Parameters 
     params: {
      
      _onKeyPurchaseHook: zeroAddress,
      _onKeyCancelHook: zeroAddress,
      _onValidKeyHook: zeroAddress,
      _onTokenURIHook: zeroAddress
       
     },
    
     
  }
  await contractCaller.fetch({
    params: options,
    onSuccess:() =>{
      showSuccess()
    },
    onError: (errori) =>{
      alert(errori.message)
    }
  })
  console.log("clicked button")
}
  const openModal = () =>{
    setIsModalVisible(true)
  }
  const hideModal = () => {
    setIsModalVisible(false)
  }
  const handleOk = () => {
    hideModal()
    callEventHook()
  }
  const showSuccess = () => {
    setIsComfirmVisible(true)
  }
   const hideSuccess = () =>{
     setIsComfirmVisible(false)
   }
   const successOk = () => {
     setIsComfirmVisible(false)
   }
   const {Option} = Select
   const changeNetwork = (value) => {
   setnetworkAddress(value)
   }
   console.log(networkAddress)
   return  <div className='lock-container'>
    
   <Modal title="Comfirmation  " visible={isModalVisible} onOk={handleOk} onCancel={hideModal} okText="Comfirm">
       <p><CheckCircleFilled style={{fontSize: "30px", color: "#1890ff", marginRight: "26px"}}/> <span className='modal-text'>Your Almost  Done</span></p>
        <p> <span className='modal-text-2'>click Comfirm button to approve this address as Your Lock</span></p>
       <Paragraph copyable>{exiAddress}  </Paragraph> 
   </Modal>
   <Modal title="Success" visible={isComfirmVisible} onOk={successOk} onCancel={hideSuccess} >
     <CheckCircleFilled style={{marginLeft: "200px", fontSize: "70px", color: "#40a9ff"}}/> <br />
     <p style={{marginLeft: "80px", marginTop: "10px", textTransform: "capitalize"}}>awesome your lock has been successful wired up</p>
   </Modal>
   <div className='select-net' style={{display: "flex", width :"100%", justifyContent: "space-between", marginBottom: "20px"}}>
     <p style={{textTransform: "capitalize", fontSize: "15px"}}>select network</p>  <Select defaultValue="Rinkeby"  style={{width: 220}} onChange={changeNetwork}>
        <Option value="0x910F56Fb797D9c7a978a08e73D7280e67eb81372">Rinkeby Testnet Network</Option>
        <Option value="disabled" disabled>Ethereum mainnet</Option>
        <Option value="0xF705b2dd649bbCB9418D08c1fF508a983f923516">Polygon</Option>
        <Option value="0xAC82F15D80b8D98E3fBb7707C9736EEbE1F655F2">BSC</Option>
      </Select>
   </div>
      <h2 className='title'>Bring Your Own NFT</h2>
      
      <div className='all-inputs'>
     <input type="text" value={exiAddress} placeholder="Your  NFT  Address" onChange={ e => setExiAddress(e.target.value)}  className="input_box"/>
     <input type="text" value={lockAddress} placeholder="Your  Lock  Address" onChange={ e => setLockAddress(e.target.value)}   className="input_box"/>
    
       
      </div>
     <button onClick={config} className="btn change-btn">create lock</button>
     
    </div>


     
  
}

export default LockConfig;
